/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LeaderRatingsAggregationsService {

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static leaderRatingsAggregationsRetrieve({
        providerId,
    }: {
        providerId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/leader-ratings-aggregations/{provider_id}/',
            path: {
                'provider_id': providerId,
            },
        });
    }

}
